'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _addInfoModalTemplate = require('./addInfoModalTemplate.html');

var _addInfoModalTemplate2 = _interopRequireDefault(_addInfoModalTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commentModal = {

    bindings: {
        label: '@',
        onCommentEntered: '&',
        comment: '@'
    },

    template: '  <button type="button" ng-click="$ctrl.openModal();" class="button button-picton-blue button-outline button-font icon-right ion-plus margin--top-xs">\n                        {{ $ctrl.label | translate }}\n                    </button>',

    controller: function controller($state, $scope, $ionicModal, $ionicLoading) {
        var _this = this;

        this.$state = $state;

        this.modal = $ionicModal.fromTemplate(_addInfoModalTemplate2.default, {
            scope: $scope
        });

        this.$onInit = function () {
            _this.label = _this.label;
            _this.comment = _this.comment;
        };

        this.openModal = function () {
            _this.modal.show();
        };

        this.closeModal = function () {
            _this.modal.hide();
        };

        this.addComment = function () {
            _this.onCommentEntered({ "comment": _this.comment });
            _this.modal.hide();
        };
    }
};

exports.default = commentModal;


/** WEBPACK FOOTER **
 ** ./src/app/directives/addInfoModal/addInfoModal.js
 **/